import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Exporting data — 2 frames: export button -> file downloads.
function EXButton(): JSX.Element {
  return (
    <SimShell step={1} total={2} title="Export">
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="rounded border border-accent/40 bg-accent/10 text-accent px-2 py-0.5">
          Export CSV
        </span>
        <span className="rounded border border-dash-border text-dash-secondary px-2 py-0.5">
          Export site content (ZIP)
        </span>
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        Articles, Brainstorm history, and the site hub each carry an export
      </div>
    </SimShell>
  );
}

function EXDownload(): JSX.Element {
  return (
    <SimShell step={2} total={2} title="Download">
      <div className="rounded border border-success/40 bg-success/10 px-3 py-2 text-xs">
        <div className="font-mono text-dash-primary">articles-2026-05-28.csv</div>
        <div className="text-[10px] font-mono uppercase text-success mt-0.5">
          downloaded — opens in any spreadsheet
        </div>
      </div>
    </SimShell>
  );
}

export function ExportSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <EXButton />, label: 'Find the export control', duration: D },
        { frame: <EXDownload />, label: 'The file downloads', duration: D },
      ]}
    />
  );
}
